import { useNavigate } from "react-router";
import { Segmented } from "@agentsaas/ui";
import { useT } from "../app/i18n";
import type { ProjectSection } from "./ProjectChrome";

type Work = Exclude<ProjectSection, "team" | "rooms" | "meetings">;

/** 手机"协作" tab 顶部：任务 / PR / 邮件 / 资产 切换 */
export function WorkSwitch({ pid, active }: { pid: string; active: Work }) {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <div className="work-switch">
      <Segmented<Work>
        label={t("mobile.tab.work")}
        value={active}
        onChange={(v) => navigate(`/p/${pid}/${v}`, { replace: true })}
        options={[
          { value: "tasks", label: t("pnav.tasks"), icon: "board" },
          { value: "pulls", label: t("pnav.pulls_short"), icon: "pr" },
          { value: "mail", label: t("pnav.mail"), icon: "mail" },
          { value: "assets", label: t("pnav.assets"), icon: "image" },
        ]}
      />
    </div>
  );
}
